import React from 'react';
import { Link } from 'react-router-dom'


function Nav() {
    return (
        <div>
        <div className="button-row-5">
        <div><Link to="/map"><button className="map-button-sm center">Back</button></Link></div>
        <div><Link to="/watershed/lower"><button className="map-button center">Lower Roaring Fork</button></Link></div>
        <div><Link to="/watershed/middle"><button className="map-button center">Middle Roaring Fork</button></Link></div>
        <div><Link to="/watershed/upper"><button className="map-button center">Upper Roaring Fork</button></Link></div>
      </div>
        </div>
    )
}

export default Nav
